import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class DeliveryLeadTime extends Component {
  /** @type {AbortController} */
  #abortController = new AbortController();
 
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#abortController;

    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.#onVariantUpdate), { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#section = null;
    this.#abortController.abort();
  }

  /**
   * Updates the delivery lead time label when variant is updated.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDeliveryLeadTime = event.detail.data.html.querySelector(`delivery-lead-time[data-block-id="${this.dataset.blockId}"]`);
      
    if (!newDeliveryLeadTime) return;

    morph(this, newDeliveryLeadTime, { childrenOnly: true });
  };
}

if (!customElements.get('delivery-lead-time')) {
  customElements.define('delivery-lead-time', DeliveryLeadTime);
}
